import { useState, useEffect, createContext, useContext } from "react";
import { getCompanyData } from "./api-service";

const CompanyDataContext = createContext("CompanyData");

export const CompanyDataProvider = ({ children }) => {
  const [companyData, setCompanyData] = useState({ loaded: false });

  useEffect(() => {
    const setData = async () => {
      const clearbitData = await getCompanyData();
      setCompanyData(clearbitData);
    };

    setData();
  }, []);

  return <CompanyDataContext.Provider value={companyData}>{children}</CompanyDataContext.Provider>;
};

export const useCompanyData = () => {
  const companyData = useContext(CompanyDataContext);

  return companyData;
};
